import { css, type Theme } from "@emotion/react";
import type { FC, ReactNode } from "react";

/**
 * Similar to Pedal's Button Container but with half the gap/margin
 * {@link https://github.com/turo/design-system-frontend-core/blob/42b9132fe19713952d2c28569aac47546946ae1f/src/components/buttons/ButtonContainer.styles.ts#L25-L37}
 */
export const otpButtonContainerStyles = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.gutters.gutter_8};
`;

interface OTPButtonContainerProps {
  children: [ReactNode, ReactNode];
}

/**
 * A convenience component set apply a different gap then most of the children in OTPForm.
 */
export const OTPButtonContainer: FC<OTPButtonContainerProps> = ({
  children,
}) => {
  return <div css={otpButtonContainerStyles}>{children}</div>;
};
